import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import useGetDeviceType from "../../../../../hooks/useGetDeviceType"
import { TStore } from "../../../../../store/Store"
import { useModal } from "../../../../../hooks/useModal"
import { setSitesFilters } from "../../../../../pages/Projects/ProjectSlice"
import { SitesFilters } from "../../../../../pages/Sites/SiteSlice"
import { useGetCitiesQuery, useLazyGetCountryStatesQuery } from "../../../../../pages/Common/commonService"
import { useLazyGetAllSitesQuery } from "../../../../../pages/Sites/SiteService"
import { Countries } from "../../../../../enums/dropdownValues"

const useSitesFilter = () => {
    const dispatch = useDispatch()

    const [openAddForm, setOpenAddForm] = useState(false)
    const [isActive, setActive] = useState(false)

    const { isShown, toggle } = useModal()
    const { filterValues } = useSelector((store: TStore) => store.Projects)
    const [getCountryStates, { data: statesList }] = useLazyGetCountryStatesQuery()
    const { data: citiesList } = useGetCitiesQuery(
        {
            state_id: filterValues?.state?.map((i: any) => i.id),
        },
        {
            skip: !filterValues.state?.length,
        }
    )
    const [getAllSites, { data: sitesData, isLoading: isSitesLoading }] = useLazyGetAllSitesQuery()
    const [showAllSites, setShowAllSites] = useState(false)
    const displayedSites = showAllSites ? sitesData?.data : sitesData?.data?.slice(0, 17)
    const { deviceType } = useGetDeviceType()

    const toggleAccordion = () => {
        setActive(value => !value)
    }

    const resetFilters = () => {
        dispatch(
            setSitesFilters({
                site: "",
                pincode: "",
            })
        )
    }
    const handleStateChange = (value: string | number | [{ id: number; title: string }]) => {
        dispatch(
            setSitesFilters({
                ...filterValues,
                state: value,
            })
        )
    }
    const handleCityChange = (value: string | number | [{ id: number; title: string }]) => {
        dispatch(
            setSitesFilters({
                ...filterValues,
                city: value,
            })
        )
    }
    const handleAddedByChange = (value: string | number | [{ id: number; title: string }]) => {
        dispatch(
            setSitesFilters({
                ...filterValues,
                addedBy: value,
            })
        )
    }
    const handleCountryChange = (value: string | number | [{ id: number; title: string }]) => {
        dispatch(
            setSitesFilters({
                ...filterValues,
                country: value,
            })
        )
    }
    const resetInternalFilters = () => {
        dispatch(
            setSitesFilters({
                ...filterValues,
                state: [],
                city: [],
                status: {},
                siteType: {},
                addedBy: [],
                country: {},
            })
        )
    }
    const handleFilterChange = (key: keyof SitesFilters, value: string | number | [{ id: number; title: string }]) => {
        dispatch(
            setSitesFilters({
                ...filterValues,
                [key]: value,
            })
        )
    }

    const applyInternalFilters = () => {
        toggle()
        dispatch(
            setSitesFilters({
                ...filterValues,
            })
        )
    }
    const closeFilter = () => {
        return toggle()
    }
    const getCountryTitleById = (id: number) => {
        return Countries.find(country => country.id === id)?.title || "-"
    }
    const states = {
        filterValues,
        deviceType,
        openAddForm,
        isShown,
        isActive,
        states: statesList,
        cities: citiesList,
        sitesData,
        isSitesLoading,
        showAllSites,
        displayedSites,
    }
    const functions = {
        resetFilters,
        handleFilterChange,
        setOpenAddForm,
        toggle,
        closeFilter,
        setActive,
        toggleAccordion,
        resetInternalFilters,
        applyInternalFilters,
        handleStateChange,
        handleCityChange,
        handleAddedByChange,
        getAllSites,
        setShowAllSites,
        handleCountryChange,
        getCountryStates,
        getCountryTitleById,
    }

    return {
        states,
        functions,
    }
}

export type SitesFilterStates = ReturnType<typeof useSitesFilter>["states"]
export type SitesFilterFunctions = ReturnType<typeof useSitesFilter>["functions"]

export default useSitesFilter
